import { observable } from 'mobx';
import type { ElementAttachFileResponseArgs } from '@this/domain/element_attach_file';
import ElementAttachFile, { convertElementAttachFileResponseToArgs } from '@this/domain/element_attach_file';
import moment from '@this/lib/moment';

export type WifiElementResponseArgs = {
  id: number;
  summary: string;
  started_at: string;
  ended_at: string;
  reservation_number?: string;
  element_attach_files?: { [key: string]: ElementAttachFileResponseArgs[] };
};

export type WifiElementArgs = {
  id: number;
  summary: string;
  startedAt: moment.Moment;
  endedAt: moment.Moment;
  reservationNumber: string;
  elementAttachFiles: ElementAttachFile[];
};

export const convertWifiElementResponseToArgs = (response: WifiElementResponseArgs) => {
  const args: WifiElementArgs = {
    id: response.id,
    summary: response.summary,
    startedAt: moment(response.started_at),
    endedAt: response.ended_at ? moment(response.ended_at) : moment(response.started_at).add(1, 'hour'),
    reservationNumber: response.reservation_number || '',
    elementAttachFiles: response.element_attach_files
      ? Object.values(response.element_attach_files)
          .flat()
          .map(file => new ElementAttachFile(convertElementAttachFileResponseToArgs(file)))
      : []
  };
  return args;
};

export default class WifiElement {
  @observable id: number;
  @observable summary: string;

  @observable
  startedAt: moment.Moment;

  @observable
  endedAt: moment.Moment;

  @observable
  reservationNumber: string;

  @observable
  elementAttachFiles: ElementAttachFile[];

  constructor(args: WifiElementArgs) {
    this.id = args.id;
    this.summary = args.summary;
    this.startedAt = args.startedAt;
    this.endedAt = args.endedAt;
    this.reservationNumber = args.reservationNumber;
    this.elementAttachFiles = args.elementAttachFiles;
  }

  get type() {
    return 'wifi';
  }

  get startDate() {
    return this.startedAt;
  }

  get endDate() {
    return this.endedAt;
  }

  get title() {
    return 'WiFi';
  }

  get name() {
    return this.title;
  }

  get mappingDescription() {
    return this.title;
  }

  detail() {
    return '';
  }
}
